var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M437.1,75c-5.9-5.9-15.4-5.9-21.2,0s-5.9,15.4,0,21.2C458.5,138.8,482,195.6,482,256s-23.5,117.2-66.1,159.8 c-5.9,5.9-5.9,15.4,0,21.2c5.9,5.9,15.4,5.8,21.2,0c48.3-48.3,74.9-112.6,74.9-181S485.4,123.3,437.1,75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.6,120.4c-5.9-5.9-15.4-5.9-21.2,0c-5.9,5.9-5.9,15.4,0,21.2c30.5,30.5,47.3,71.2,47.3,114.4 s-16.8,83.9-47.3,114.4c-5.9,5.9-5.9,15.4,0,21.2c5.9,5.9,15.4,5.9,21.2,0c36.2-36.2,56.1-84.4,56.1-135.6S427.8,156.6,391.6,120.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.2,165.9c-5.9-5.9-15.4-5.9-21.2,0c-5.9,5.9-5.9,15.4,0,21.2c18.4,18.4,28.5,42.9,28.5,68.9 s-10.1,50.5-28.5,68.9c-5.9,5.9-5.9,15.4,0,21.2c5.9,5.9,15.4,5.9,21.2,0c24.1-24.1,37.3-56.1,37.3-90.1S370.3,189.9,346.2,165.9 L346.2,165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,256c0-60.4,23.5-117.2,66.1-159.8c5.9-5.9,5.9-15.4,0-21.2c-5.9-5.9-15.4-5.9-21.2,0 C26.6,123.3,0,187.6,0,256s26.6,132.7,74.9,181c5.9,5.9,15.4,5.9,21.2,0c5.9-5.9,5.9-15.4,0-21.2C53.5,373.2,30,316.4,30,256 L30,256z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2,256c0-43.2,16.8-83.9,47.3-114.4c5.9-5.9,5.9-15.4,0-21.2c-5.9-5.9-15.4-5.9-21.2,0 C84.2,156.6,64.2,204.8,64.2,256s19.9,99.4,56.1,135.6c5.9,5.9,15.4,5.9,21.2,0c5.9-5.9,5.9-15.4,0-21.2 C111,339.9,94.2,299.2,94.2,256z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,165.9c-5.9-5.9-15.4-5.9-21.2,0c-24.1,24.1-37.3,56.1-37.3,90.1s13.3,66.1,37.3,90.1 c5.9,5.9,15.4,5.9,21.2,0c5.9-5.9,5.9-15.4,0-21.2c-18.4-18.4-28.5-42.9-28.5-68.9s10.1-50.5,28.5-68.9 C192.9,181.2,192.9,171.7,187,165.9L187,165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,192.8c-34.8,0-63.2,28.4-63.2,63.2s28.4,63.2,63.2,63.2s63.2-28.4,63.2-63.2S290.8,192.8,256,192.8z  M256,289.2c-18.3,0-33.2-14.9-33.2-33.2s14.9-33.2,33.2-33.2s33.2,14.9,33.2,33.2S274.3,289.2,256,289.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensor);
export default __webpack_public_path__ + "static/media/sensor.4a8ceaa1f910529a508a9176c9230df0.svg";
export { ForwardRef as ReactComponent };